"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAgreementEdit = void 0;
const Base_1 = require("./Base");
exports.PostAgreementEdit = {
    url: Base_1.URL_BASE + "/AgreementEdit",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostAgreementEdit.js.map